import { Component, Input } from '@angular/core';

@Component({
  selector: 'trpx-testimonial-dubai',
  templateUrl: './testimonial-dubai.component.html',
  styleUrls: ['./testimonial-dubai.component.scss']
})
export class TestimonialDubaiComponent {
@Input() slides: any;
@Input() isOrange: boolean = false;

  constructor() {}
  ngOnInit(): void {}

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          variableWidth: false,
        },
      },
    ],
  };

}
